import { render, staticRenderFns } from "./NotExist.vue?vue&type=template&id=77a64cab&scoped=true&"
import script from "./NotExist.vue?vue&type=script&lang=js&"
export * from "./NotExist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a64cab",
  null
  
)

export default component.exports